import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(theme => ({
  root: {
    padding: theme.spacing(4),
    '@media print': {
      padding: theme.spacing(2),
    },
  },
  title: {
    marginBottom: theme.spacing(3),
    fontWeight: 600,
  },
  section: {
    marginBottom: theme.spacing(2),
  },
  label: {
    fontWeight: 600,
    marginBottom: theme.spacing(0.5),
  },
  value: {
    marginBottom: theme.spacing(1),
  },
  valueWithIcon: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: theme.spacing(0.5),
    verticalAlign: 'middle',
  },
  statusIcon: {
    marginRight: theme.spacing(0.5),
    fontSize: '1.2rem',
  },
  activeIcon: {
    color: theme.palette.success.main,
  },
  inactiveIcon: {
    color: theme.palette.grey[500],
  },
  criticalityLowIcon: {
    color: theme.palette.info.main,
  },
  criticalityMediumIcon: {
    color: theme.palette.warning.main,
  },
  criticalityHighIcon: {
    color: theme.palette.error.main,
  },
  deadlinePast: {
    color: '#f44336',
    fontWeight: 'bold',
  },
  reminderPast: {
    color: '#ff9800',
  },
  divider: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
    borderTop: '1px solid #e0e0e0',
  },
  sectionTitle: {
    marginBottom: theme.spacing(2),
    fontWeight: 600,
  },
  stepContainer: {
    marginBottom: theme.spacing(2),
    padding: theme.spacing(2),
    border: '1px solid #e0e0e0',
    borderRadius: 4,
    pageBreakInside: 'avoid',
  },
  stepTitle: {
    fontWeight: 600,
    marginBottom: theme.spacing(1),
  },
  stepContent: {
    marginBottom: theme.spacing(1),
  },
  mandatoryBadge: {
    marginLeft: 8,
    border: '1px solid #e0e0e0',
    borderRadius: 16,
    padding: '2px 8px',
    fontSize: '0.75rem',
    fontWeight: 'normal',
    display: 'inline-block',
    verticalAlign: 'middle',
  },
  stepStatus: {
    marginLeft: 8,
    fontSize: '0.875rem',
    fontWeight: 'normal',
    color: theme.palette.text.secondary,
  },
}));
